import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { viewOrder } from "./_requests";
import { viewSettingsMore } from "../Settings/_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Container, Button, Row, Col, Table } from "reactstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { formatDate } from "../../helpers/FunctionHelpers";
import { toast, ToastContainer } from "react-toastify";

const InvoiceDownload = () => {
    const { id } = useParams();
    const [order, setOrder] = useState<any>({});
    const [companySettings, setCompanySettings] = useState<any>({});
    const [loading, setLoading] = useState(true);
    const invoiceRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const fetchOrderData = async () => {
            try {
                const orderRes = await viewOrder(id);
                if (orderRes.status && orderRes.data) {
                    setOrder(orderRes.data);
                }

                // Fetch company settings (Assuming ID 1 is the main settings)
                const settingsRes = await viewSettingsMore(1);
                console.log("settingsRes==========", settingsRes);
                if (settingsRes) {
                    setCompanySettings(settingsRes);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrderData();
    }, [id]);
    console.log("order===========", order);
    console.log("companySettings===========", companySettings);
    const handleDownload = async () => {
        if (!invoiceRef.current) return;
        const canvas = await html2canvas(invoiceRef.current, {
            scale: 2,
            useCORS: true,
            logging: false,
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        // If height exceeds A4, we might need multiple pages, but for typical invoices, one page is enough.
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`Invoice_${order?.order_code_id || id}.pdf`);
    };

    if (loading) return <div className="p-4 text-center">Loading...</div>;

    const formatAmount = (amount: number | undefined): string =>
        amount !== undefined ? new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount) : "0.00";

    // Simple toWords function (can be improved)
    const toWords = (num: number) => {
        const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
        const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const n = ('0000000' + num).slice(-7).match(/^(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return '';
        let str = '';
        str += (Number(n[1]) !== 0) ? (a[Number(n[1])] || b[Number(n[1][0])] + ' ' + a[Number(n[1][1])]) + 'Lakh ' : '';
        str += (Number(n[2]) !== 0) ? (a[Number(n[2])] || b[Number(n[2][0])] + ' ' + a[Number(n[2][1])]) + 'Thousand ' : '';
        str += (Number(n[3]) !== 0) ? a[Number(n[3])] + 'Hundred ' : '';
        str += (Number(n[4]) !== 0) ? ((str !== '') ? 'and ' : '') + (a[Number(n[4])] || b[Number(n[4][0])] + ' ' + a[Number(n[4][1])]) + 'Only ' : 'Only';
        return str;
    };

    const subTotal = order?.sub_total_amount || 0;
    const taxAmount = order?.tax_amount || 0;
    const netAmount = order?.total_amount || 0;
    const cgst = taxAmount / 2;
    const sgst = taxAmount / 2;

    return (
        <div className="page-content">
            <Container fluid className="px-3 my-2">
                <div className="mb-3 d-flex justify-content-between align-items-center no-print" style={{ maxWidth: "1000px", margin: "0 auto" }}>
                    <Button color="dark" onClick={() => window.history.back()}>
                        <i className="ri-arrow-left-line me-1"></i> Back to Order
                    </Button>
                    <div>
                        <Button color="info" className="me-2" onClick={() => window.print()}>
                            <i className="ri-printer-line me-1"></i> Print
                        </Button>
                        <Button color="success" onClick={handleDownload}>
                            <i className="ri-download-2-line me-1"></i> Download PDF
                        </Button>
                    </div>
                </div>

                <div
                    ref={invoiceRef}
                    className="invoice-container shadow-none"
                    style={{
                        backgroundColor: "#fff",
                        padding: "15px",
                        // border: "2px solid #000",
                        color: "#000",
                        fontSize: "12px",
                        lineHeight: "1.2",
                        width: "100%",
                        maxWidth: "1000px",
                        margin: "0 auto"
                    }}
                >
                    {/* Header Section */}
                    <div className="text-center position-relative   border-bottom border-dark">
                        <h1 className="fw-bold mb-0" style={{ fontSize: "24px", letterSpacing: "1px" }}>CASH BILL</h1>
                        <span className="position-absolute end-0 bottom-0 mb-1 pe-1" style={{ fontSize: "9px" }}>(Original for Recipient)</span>
                    </div>

                    <Row className="m-0 border-bottom border-dark border-right border-left ">
                        <Col xs={6} className="p-2 border-end border-dark">
                            <div className="d-flex align-items-center mb-2">
                                <img
                                    src={`${process.env.REACT_APP_API_URL?.replace('/v1', '')}/uploads/logo/logo.png`}
                                    alt="Logo"
                                    style={{ height: "40px", marginRight: "10px" }}
                                    onError={(e) => (e.currentTarget.style.display = 'none')}
                                />
                                <h2 style={{ fontSize: "14px", fontWeight: "Bold", margin: "0" }}>{companySettings?.name?.toUpperCase() || ""}</h2>
                            </div>
                            <p style={{ fontSize: "10px", whiteSpace: "pre-line", margin: "0", lineHeight: "1.4" }}>
                                {companySettings?.address || ""}
                                <br />
                                Mobile : {companySettings?.mobile_number || ""}
                                <br />
                                GST NO : {companySettings?.gst_no || ""}
                            </p>
                        </Col>
                        <Col xs={6} className="p-2">
                            <div className="d-flex flex-column h-100">
                                <div className="fw-bold mb-1" style={{ fontSize: "11px" }}>INVOICE / BILLED TO</div>
                                <div style={{ fontSize: "11px" }}>
                                    <div className="fw-bold text-uppercase mb-1">{order?.user?.name || "Customer"}</div>
                                    <div className="mb-2" style={{ lineHeight: "1.3" }}>{order?.shipping_address}</div>
                                    <div className="d-flex">
                                        <div className="fw-bold" style={{ width: "70px" }}>Phone No</div>
                                        <div style={{ flex: 1 }}>: {order?.user?.mobile_number}</div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="fw-bold" style={{ width: "70px" }}>GST NO</div>
                                        <div style={{ flex: 1 }}>: {order?.user?.gst_no || ""}</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="m-0 border-bottom border-dark border-right border-left">
                        <Col xs={6} className="p-2">
                            <div className="d-flex mb-1" style={{ fontSize: "11px" }}>
                                <div className="fw-bold" style={{ width: "100px" }}>Invoice No.</div>
                                <div>: {order?.order_code_id || ""}</div>
                            </div>
                            <div className="d-flex mb-1" style={{ fontSize: "11px" }}>
                                <div className="fw-bold" style={{ width: "100px" }}>Invoice Date</div>
                                <div>: {order?.order_date ? new Date(order.order_date).toLocaleDateString('en-IN') : ""}</div>
                            </div>
                            <div className="d-flex mb-1" style={{ fontSize: "11px" }}>
                                <div className="fw-bold" style={{ width: "100px" }}>State</div>
                                <div>: <span className="fw-bold">TAMIL NADU</span></div>
                            </div>
                            <div className="d-flex" style={{ fontSize: "11px" }}>
                                <div className="fw-bold" style={{ width: "100px" }}>State Code</div>
                                <div>: <span className="fw-bold">33</span></div>
                            </div>
                        </Col>
                        <Col xs={6} className="p-2 h-100"></Col>
                    </Row>

                    {/* Items Table */}
                    <div className="table-responsive">
                        <Table className="mt-0 mb-0 invoice-table" style={{ fontSize: "10px" }}>
                            <thead>
                                <tr className="text-center">
                                    <th style={{ width: "35px", verticalAlign: "middle" }} rowSpan={2}>SlNo</th>
                                    <th style={{ width: "170px", verticalAlign: "middle" }} rowSpan={2}>ITEM NAME</th>
                                    <th style={{ width: "45px", verticalAlign: "middle" }} rowSpan={2}>HSN CODE</th>
                                    <th style={{ width: "35px", verticalAlign: "middle" }} rowSpan={2}>Qty</th>
                                    <th style={{ width: "35px", verticalAlign: "middle" }} rowSpan={2}>UOM</th>
                                    <th style={{ width: "45px", verticalAlign: "middle" }} rowSpan={2}>Rate</th>
                                    <th style={{ width: "55px", verticalAlign: "middle" }} rowSpan={2}>Taxable Amount</th>
                                    <th style={{ width: "90px" }} colSpan={2}>CGST</th>
                                    <th style={{ width: "90px" }} colSpan={2}>SGST</th>
                                    <th style={{ width: "55px", verticalAlign: "middle" }} rowSpan={2}>Total Amount</th>
                                </tr>
                                <tr className="text-center" style={{ fontSize: "9px" }}>
                                    <th style={{ width: "30px" }}>%</th>
                                    <th style={{ width: "60px" }}>Amt</th>
                                    <th style={{ width: "30px" }}>%</th>
                                    <th style={{ width: "60px" }}>Amt</th>
                                </tr>
                            </thead>
                            <tbody>
                                {order?.orderItems?.map((item: any, index: number) => (
                                    <tr key={item?.id || index} className="invoice-item-row" style={{ height: "30px" }}>
                                        <td className="text-center">{index + 1}.</td>
                                        <td className="noBorderBotton">
                                            {item?.product?.billing_name || item?.product?.name || "Product"}

                                        </td>
                                        <td className="text-center noBorderBotton">{item?.product?.hsn_code || "0403"}</td>
                                        <td className="text-center noBorderBotton">{item?.quantity?.toFixed(2)}</td>
                                        <td className="text-center noBorderBotton">Lite</td>
                                        <td className="text-end noBorderBotton">{formatAmount(item?.mrp)}</td>
                                        <td className="text-end noBorderBotton">{formatAmount(item?.total_amount)}</td>
                                        <td className="text-center noBorderBotton"></td>
                                        <td className="text-end noBorderBotton"></td>
                                        <td className="text-center noBorderBotton"></td>
                                        <td className="text-end noBorderBotton"></td>
                                        <td className="text-end noBorderBotton">{formatAmount(item?.total_amount)}</td>
                                    </tr>
                                ))}
                                {/* Filling space */}
                                {Array.from({ length: Math.max(0, 10 - (order?.orderItems?.length || 0)) }).map((_, i) => (
                                    <tr key={`empty-${i}`} className="invoice-item-row" style={{ height: "30px" }}>
                                        <td className="noBorderBotton">&nbsp;</td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                        <td className="noBorderBotton"></td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="border-top border-dark">
                                    <td colSpan={3} className="border-0">
                                        <div className="fw-bold" style={{ fontSize: "11px" }}>Total Qty : {order?.orderItems?.reduce((acc: number, item: any) => acc + (item?.quantity || 0), 0)}</div>
                                    </td>
                                    <td colSpan={4} className="border-0 text-center">
                                        <div className="fw-bold" style={{ fontSize: "11px" }}>Gross Amount : {formatAmount(subTotal)}</div>
                                    </td>
                                    <td colSpan={4} className="p-0 border-dark">
                                        <div className="d-flex justify-content-between px-1 py-1" style={{ fontSize: "10px" }}>
                                            <div className="fw-bold">SGST VALUE</div>
                                            <div>: {formatAmount(sgst)}</div>
                                        </div>
                                        <div className="d-flex justify-content-between px-1 py-1 border-top border-dark" style={{ fontSize: "10px" }}>
                                            <div className="fw-bold">CGST VALUE</div>
                                            <div>: {formatAmount(cgst)}</div>
                                        </div>
                                    </td>
                                    <td className="text-end fw-bold align-middle" style={{ fontSize: "10px" }}>{formatAmount(netAmount)}</td>
                                </tr>
                                <tr className="border-top border-dark">
                                    <td colSpan={11} className="py-1 text-end ps-2">
                                        <span className="fw-bold" style={{ fontSize: "11px" }}>NET AMOUNT :</span>
                                    </td>
                                    <td className="text-end fw-bold py-1" style={{ fontSize: "12px" }}>{formatAmount(netAmount)}</td>
                                </tr>
                            </tfoot>
                        </Table>
                    </div>

                    <div className="p-0 border border-top-0 border-dark">
                        <div style={{ padding: "10px" }}>
                            <p className="fw-bold mb-3" style={{ fontSize: "11px" }}>Rupees - {toWords(Math.round(order?.total_amount || 0))}</p>
                            <p className="fw-bold mb-1" style={{ fontSize: "11px" }}>BANK DETAILS</p>
                            <div style={{ fontSize: "10px", lineHeight: "1.5" }}>
                                BANK NAME : {companySettings?.bank_name || ""}<br />
                                A/C NO : {companySettings?.account_no || ""}<br />
                                BRANCH : {companySettings?.branch || ""}<br />
                                IFSC CODE : {companySettings?.ifsc_code || ""}
                            </div>
                        </div>
                    </div>

                    <Row className="m-0 border border-top-0 border-dark" style={{ minHeight: "100px" }}>
                        <Col xs={6} className="p-2 border-end border-dark text-center d-flex flex-column justify-content-end">
                            <div className="fw-bold mb-2" style={{ fontSize: "11px" }}>Customer's Signature</div>
                        </Col>
                        <Col xs={6} className="p-2 text-center d-flex flex-column justify-content-between">
                            <div className="fw-bold" style={{ fontSize: "11px" }}>For {companySettings?.name?.toUpperCase() || "MAHATVA DAIRY INDUSTRIES"}</div>
                            <div className="fw-bold mb-2" style={{ fontSize: "10px" }}>Authorised Signatory</div>
                        </Col>
                    </Row>
                </div>

                <style>{`
.invoice-table {
    border-collapse: collapse !important;
    width: 100%;
}
  .border-right{
    border-right: 1px solid #000 !important;
}
 .border-left{
    border-left: 1px solid #000 !important;
}
.invoice-table th,
.invoice-table td {
    border: 1px solid #000;
    padding: 2px 4px;
    vertical-align: middle;
    line-height: 1.1;
}

/* remove inner row horizontal lines */
.invoice-table tbody td {
    border-top: none !important;
    border-bottom: none !important;
}

/* keep outer table border */
.invoice-table {
    border: 1px solid #000;
}

/* keep header borders */
.invoice-table thead th {
    background-color: #fff !important;
    font-weight: bold;
    border: 1px solid #000 !important;
}

/* keep footer borders */
.invoice-table tfoot td {
    border-top: 1px solid #000 !important;
}

.invoice-container {
    min-height: 900px;
}

@media print {
    .no-print {
        display: none !important;
    }
    .invoice-container {
        box-shadow: none !important;
        padding: 15px !important;
    }
    body {
        padding: 0;
        margin: 0;
        background: #fff;
    }
    @page {
        size: A4;
        margin: 10mm;
    }
}
`}</style>
            </Container>
        </div>
    );
};

export default InvoiceDownload;
